import { Button, Chip, useMediaQuery, useTheme, Link } from '@mui/material';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { secretManager } from 'services/api/config';
import useDiscoveryBanner from './hooks';
import {
  StyledCTAButton,
  StyledCTAContainer,
  StyledImageBox,
  StyledSubtitle,
  StyledTitle,
} from './styled';

const SAMPLE_PACKS_INFO_URL = `${secretManager.loudlyDomain}/sample-packs`;

const DiscoveryBanner = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const { CTAButtonText, handleCTAButtonClick } = useDiscoveryBanner();

  const handleClick = useCallback(() => {
    handleCTAButtonClick();
  }, [handleCTAButtonClick]);

  return (
    <StyledImageBox>
      <Chip variant="filled" color="secondary" label={t('general:new')} />
      <StyledTitle variant="h1">
        {t('discoveryPage:discoveryBanner:title')}
      </StyledTitle>
      <StyledSubtitle variant="h2">
        {t('discoveryPage:discoveryBanner:subTitle')}
      </StyledSubtitle>
      <StyledCTAContainer>
        <StyledCTAButton variant="rounded" onClick={handleClick}>
          {CTAButtonText}
        </StyledCTAButton>
        {!isMobile && (
          <Link href={SAMPLE_PACKS_INFO_URL}>
            <Button variant="text">
              {t('discoveryPage:discoveryBanner:learnMore')}
            </Button>
          </Link>
        )}
      </StyledCTAContainer>
    </StyledImageBox>
  );
};

export default DiscoveryBanner;
